import { SchedulerItem, SchedulerItemContent } from '@progress/kendo-react-scheduler';
import { useCallback } from 'react';
import { COLUMNSTYPE, LOCALSTORAGE_KEY, MEDIACATEGORIES, MODULE, TX_MODE, TX_STATUS } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import { PlanningHelper } from './helper/PlanningHelper';
import moment from 'moment';

const CustomPlanningItem = (props) => {

  const { onFocus } = props;

  const columnPreference = PlanningHelper.getColumnPreference();
  const planningPreference = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
  const showFormat = planningPreference?.data[0]?.value?.ShowFormat && props?.dataItem?.mediaEpisode?.Formats?.length > 0;
  const showNoSegment = planningPreference?.data[0]?.value?.ShowNoSeg && !props?.dataItem?.Segment_id;
  const showContract = planningPreference?.data[0]?.value?.ShowContract && props?.dataItem?.MediaDealRight_id;
  const showInvalidFormat = planningPreference?.data[0]?.value?.ShowInvalidFormat ?? false;


  const IsInvalidSegmentSelected = (planneditem) => {
    if(planneditem?.dataItem?.Formats?.length > 0 && planneditem?.dataItem?.segment?.SegmentType) {
      return !planneditem?.dataItem?.Formats?.some((x) => x?.SegmentType?.SegmentCount === planneditem?.dataItem?.segment?.SegmentType?.SegmentCount);
    }
    return false;
  }

  const isInvalidSegmentSelected = IsInvalidSegmentSelected(props);

  let showTxMode = false;
  let txModeValue = '';
  let txStatus = props.dataItem?.TXStatus ? props.dataItem?.TXStatus : { SID: TX_STATUS.Transmission, Description: 'Transmission' };
  const showRecursive = (props?.dataItem?.RecursionParentProgramSchedule_id != undefined && props?.dataItem?.RecursionParentProgramSchedule_id != "") ? true : false;
  const isChanged = props?.dataItem?.isChanged ?? false;
  const scheduleDate = new Date(props.dataItem?.ScheduleDate).setUTCHours(0, 0, 0, 0);
  const channel = props?.dataItem?.Channel;
  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);
  const modify = utility.canModify(props.lockedPlaylist, MODULE.PLANNING, channel._id, scheduleDate);
  var canModify = modify.canModify;
  const lockedBy = modify.lockedBy;
  const isPlanningItemLocked = props.dataItem?.isLocked ?? false;
  const isImportant = props.dataItem?.isImportant ?? false;
  
  var style = {
    ...props.style, letterSpacing: "1px", fontWeight: "bold", ...props.dataItem.Style, border: props.selected ? '2px solid black' : '0px', pointerEvents: canModify ? 'auto' : 'none'
  }

  let uiData = columnPreference.map((item, index) => {
    if (!props?.dataItem) {
      console.error("props.dataItem is undefined", props);
      return "";
    }
  
    let value = item?.key 
      ? props?.dataItem[item?.key]?.[item?.name] // Safe access
      : props?.dataItem?.[item?.name];
  
    if (item.name === "EpisodeNumber") {
      value = value 
        ? ((props.dataItem?.mediaEpisode?.MediaCategory?.SID ?? 0) === MEDIACATEGORIES.Movie ? "NA" : "EP " + value) 
        : "";
    } 
    else if (item.name === "ExhibitionNumber") {
      value = "Exhibition: " + (typeof value === "number" ? value : value?.toString() ?? "");
    } 
    else if (item.name === "RepeatNumber") {
      value = "Repeat: " + (typeof value === "number" ? value : value?.toString() ?? "");
    } 
    else if (item.name === "SeasonNumber") {
      let temp = props.dataItem?.mediaEpisode?.SeasonNumber;
      value = temp 
        ? ((props.dataItem?.mediaEpisode?.MediaCategory?.SID ?? 0) === MEDIACATEGORIES.Movie ? "NA" : "S-" + temp) 
        : "";
    } 
    else if (item.name === "NominalDuration") {
      let finalNominalDuration = props.dataItem.customDuration ?? props.dataItem.NominalDuration;
      value = utility.convertMilisecondsToStringWithFrames(finalNominalDuration);
    } 
    else if (item.name === "TX Mode") {
      if (props.dataItem?.Segment_id !== null && (props.dataItem?.segments?.length > 0 || props.dataItem?.mediaEpisode?.segments?.length > 0)) {
        let currentSegment = props.dataItem?.segment ?? props.dataItem?.mediaEpisode?.segments.find((x) => x._id === props.dataItem?.Segment_id);
        let temp = currentSegment?.SegmentType?.TXMode 
          ? currentSegment?.SegmentType?.TXMode?.Name 
          : utility.getKeyByValue(TX_MODE, currentSegment?.SegmentType?.TXModeSID);
        showTxMode = !!temp;
        value = temp ?? "No Segments";
        txModeValue = value;
      } else {
        value = "No Segments";
        txModeValue = value;
      }
    } else if (item.name == "Break Details") {

      if(props.dataItem && props.dataItem.segment && props.dataItem.Formats && props.dataItem.Formats.length > 0) {

        let validFormat = props.dataItem.Format_id ? 
          props.dataItem.Formats.find((x) => x._id === props.dataItem.Format_id) : 
          props.dataItem.Formats.find((x) => { 
          return x?.SegmentType?.SegmentCount === props.dataItem?.segment?.SegmentType?.SegmentCount && 
            x.Channel.SID === props.dataItem.Channel.SID
        })

        if(validFormat) {
          value = `${validFormat?.Name} - ${validFormat.TotalBreakCount} BREAKS`
        }

      }

    }
    else if (item.type === COLUMNSTYPE.array) {
      value = value?.length > 0 ? (typeof value[0]?.[item.format] === "number" ? value[0][item.format] : value[0]?.[item.format]?.toString() ?? "") : "";
    } 
    else if (item.type === COLUMNSTYPE.time) {
      value = utility.convertMilisecondsToStringWithFrames(value ?? 0);
    } 
    else if (item.type === COLUMNSTYPE.date) {
      value = utility.convertMilisecondsToStringWithFrames(value ?? 0);
    } 
    else if (item.name === "Language") {
      value = props.dataItem?.segment?.Language?.Language?.Description ?? "";
    }
  
    return value && typeof value === "number" ? value : value?.toString() ?? ""; 
  });
  

  const tooltip = '(' + moment(props?.dataItem?.SlotDateTime).utc().format('HH:mm A') + ' - ' + moment(props?.dataItem?.SlotDateTime + props?.dataItem?.ActualDuration).utc().format('HH:mm A') + ')\n' + props?.dataItem?.Title + '\n' + uiData.join('\n');

  const divId = props?.id;
  let div = document.getElementById(divId)?.querySelector('div');
  if (div) {
    div.title = tooltip
  }


  const handleFocus = useCallback((event) => {
    //  props.onClick(event);
    // Call the default `onFocus` handler
    if (onFocus) {
      props.setFocusedPlanningItemPropRef(props);
      onFocus(event);
    }
  },
    [onFocus]
  );

  return <SchedulerItem {...props}
    style={style}

    onFocus={handleFocus}
    // onBlur={handleBlur}

    onClick={(event) => {
      if (event.syntheticEvent.detail == 2) {
        //dblclick
      } else {
        //singleClick
        props.onClick(event);
        props.onPlannerItemSelect(event, event.target.props.dataItem);
      }

    }}


  >
    {props.children}
    <SchedulerItemContent title={tooltip}>
      {
        uiData.map((item, index) => {
          if (item) return <div key={index + "-" + item._id} className='customItem'>{item}<br /></div>
        })
      }

    </SchedulerItemContent>
    <div style={{
      position: 'absolute', bottom: '0px', right: '0px',
      display: 'flex', flexDirection: 'row', 
      justifyContent: 'space-between',
      alignItems: 'center', fontSize: '10px', padding: (showFormat || showNoSegment || showContract || showRecursive) ? '3px' : 0,
      width: '100%',
      backgroundColor: props?.dataItem?.Style?.backgroundColor ?? "white",
      zIndex: 2,
      pointerEvents: 'none'
    }}>
    
    {/* Left side icons */}
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isPlanningItemLocked && <i className={`fa fa-lock ml-1`} style={{fontSize : '14px'}} title={'Locked'} />}
    </div>

    {/* Right side icons */}
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isImportant && <i className={"fa fa-exclamation-triangle fa-lg mr-1"} title='Important' style={{fontSize: "10px"}}/>}
      {showFormat && <i className="fa fa-cube fa-lg mr-1" title="format" />}
      {showNoSegment && <i className="fa fa-window-close fa-lg mr-1" title="no segments" />}
      {showContract && <i className="fa fa-pencil-square-o fa-lg mr-1" title="contract" />}
      {showRecursive && <i className="fa fa-bars fa-lg mr-1" title="recursive" />}
      {showInvalidFormat && isInvalidSegmentSelected && <i className="fa fa-triangle-exclamation fa-lg mr-1" title="invalid format" />}
      {isChanged && <i className={"fa fa-refresh fa-lg mr-1"} title="Changed" />}
      {txStatus.SID == TX_STATUS.Live ? <i className={"fa fa-circle fa-lg"} style={{ color: 'red' }} title="live" /> :
        txStatus.SID == TX_STATUS.Repeat ? <i className={"fa fa-registered fa-lg"} title="Repeat" /> :
          txStatus.SID == TX_STATUS.SDD ? <span className={"rounded-circle d-inline-flex"} style={{ width: '14px', height: '14px', fontSize: '9px', padding: '2px 0px 9px 3px', border: `2.2px solid ${style?.color ?? 'white'}` }} title="Delayed"><i className={"fa fa-d fa-sm"} title="Delayed" /></span> :
            txStatus.SID == TX_STATUS.Transmission ? <span className={"rounded-circle d-inline-flex"} style={{ margin:"0px 0px 2px 0px", width: '15px', height: '15px', fontSize: '6px', padding: '4.8px 0px 0px 1.5px', border: `2.2px solid ${style?.color ?? 'white'}` }} title="TX Mode"><i className={"fa fa-t fa-sm"} title="Delayed" /><i className={"fa fa-x fa-sm"} title="Delayed" /></span> : null}
    </div>
</div>


    
  </SchedulerItem>

};

export default CustomPlanningItem;